import React, { Component } from "react";
import { Helmet } from "react-helmet";

import Api from "../../../../lib/componentApi";
import getAppErrors from "../../../../lib/appErrors";

import List from "../../../../components/Users/Addresses/List";
import Submit from "./Submit";

import AppErrors from "../../../../components/Common/AppErrors";
import AppInfo from "../../../../components/Common/AppInfo";

class AddressesList extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      submitAddress: false,
      selectedAddress: "",
      errorMessage: null,
      confirmDelete: false,
      infoSection: false,
      deletedAddressId: ""
    };
  }
  handleSelectSection = addressId => {
    const { userData } = this.props;
    const { addresses } = userData;
    let selectedAddress;
    if (addressId) {
      selectedAddress =
        addresses &&
        addresses.length &&
        addresses.find(address => address.id === addressId);
    } else {
      selectedAddress = null;
    }
    if (selectedAddress === null || selectedAddress) {
      this.setState({ selectedAddress, submitAddress: true });
    }
  };
  handleCloseSection = newAddress => {
    const { getProfile } = this.props;
    if (newAddress) {
      this.setState({ submitAddress: false }, () => {
        getProfile({ shouldUpdate: true });
      });
    } else {
      this.setState({ submitAddress: false });
    }
  };
  handleRemoveAddress = addressId => {
    const { confirmDelete } = this.state;
    const { getProfile } = this.props;
    if (confirmDelete) {
      const { deletedAddressId } = this.state;
      if (deletedAddressId) {
        Api.post(
          "/api/address/delete",
          { userAddressId: deletedAddressId, force: true },
          (response, errors) => {
            if (errors) {
              if (errors === 503) {
                this.setState(() => {
                  throw errors;
                });
              } else {
                console.log(errors);
              }
            } else if (response.code) {
              const errorMessage = getAppErrors(response.code);
              this.setState({
                error:
                  (errorMessage && errorMessage.message) || response.message,
                loading: false
              });
            } else {
              if (response.status) {
                this.setState(
                  {
                    confirmDelete: false,
                    infoSection: false
                  },
                  () => {
                    getProfile({ shouldUpdate: false });
                  }
                );
              }
            }
          }
        );
      }
    } else {
      this.setState({
        confirmDelete: true,
        infoSection: true,
        deletedAddressId: addressId
      });
    }
  };
  onClickClose = section => {
    if (section === "infoSection") {
      this.setState({
        infoSection: false,
        deletedAddressId: "",
        confirmDelete: false
      });
    }
    if (section === "errorMessage") {
      this.setState({
        errorMessage: null
      });
    }
  };
  render() {
    const { onCloseSection, userData } = this.props;
    const { addresses, firstName, lastName, uid } = userData;
    const {
      submitAddress,
      selectedAddress,
      infoSection,
      errorMessage
    } = this.state;
    const infoMessage = "Are you sure you want to delete this address?";
    const buttonText = "Delete";
    const title = "Delete Home Address";
    return (
      (errorMessage && (
        <AppErrors
          message={errorMessage}
          onClickClose={() => this.onClickClose("errorMessage")}
        />
      )) ||
      ((infoSection && (
        <AppInfo
          message={infoMessage}
          title={title}
          onClickClose={() => this.onClickClose("infoSection")}
          buttonText={buttonText}
          onSubmit={() => this.handleRemoveAddress()}
        />
      )) ||
        ((submitAddress && (
          <Submit
            handleCloseSection={this.handleCloseSection}
            address={selectedAddress}
            firstName={firstName}
            lastName={lastName}
            uid={uid}
          />
        )) || (
          <div>
            <Helmet>
              <title>Addresses</title>
              <meta property="og:title" content="Addresses" />
            </Helmet>
            <div className="profile-desktop">
              {/* Header */}
              <div className="head-general with-back">
                <a
                  href="javascript: void(0)"
                  onClick={() => onCloseSection("addressSection")}
                  className="back"
                >
                  <img src="/png/chevron-left.png" />
                </a>
                <h4>Your Address</h4>
                <a
                  href="javascript: void(0)"
                  onClick={() => onCloseSection("addressSection")}
                  className="close"
                >
                  <i className="icon icon-close" />
                </a>
              </div>
              {/* Header */}

              <h4 className="hide-xs general-title">Your Address</h4>
              <div
                className="add-address"
                onClick={() => this.handleSelectSection()}
              >
                <a href="javascript: void(0)" className="visible-xs">
                  {" "}
                  <i className="icon icon-close icon-plus" />{" "}
                  <span>Add New Address</span>
                </a>
              </div>
              <List
                addresses={addresses}
                onSelectAddress={this.handleSelectSection}
                handleRemoveAddress={this.handleRemoveAddress}
              />
            </div>
            {/* .profile-desktop */}

            <div className="hide-xs">
              <div className="use-buttons mt-10px">
                <a
                  href="javascript: void(0)"
                  className="btn btn-blue"
                  onClick={() => this.handleSelectSection()}
                >
                  + Add a new address
                </a>
              </div>
              {/* .use-buttons */}
            </div>
            {/* .hide-xs */}
          </div>
        )))
    );
  }
}

export default AddressesList;
